export default "__VITE_ASSET__2c0a998d__"